import { useMutation } from '@tanstack/react-query';
import { useState } from 'react';
import { IDocument } from './models/document';
import useHttpClient from './useHttpClient';

export interface IDocRevisionReq {
  originalDocId: { native: number; };
  revisionDocId: { native: number; };
}

export interface IRevisionIdentifier {
  native: number;
  partner?: string;
}

export interface IAddDocRevisionPayload {
  addDocumentRevision: (payload: IDocRevisionReq) => Promise<IDocument>;
  loading: boolean;
  error?: Error;
  called: boolean;
  document?: IDocument;
}

const useMutateDocSaveAsRevision = (): IAddDocRevisionPayload => {
  const httpClient = useHttpClient();
  const [called, setCalled] = useState(false);

  const {
    mutate: addDocumentRevision,
    data: document,
    error,
    isPending: loading,
  } = useMutation<IDocument, Error, IDocRevisionReq>({
    mutationFn: async ({ originalDocId, revisionDocId }: IDocRevisionReq) => {
      const response = await httpClient.post(
        `/documents/${originalDocId.native}/revisions`,
        revisionDocId
      );
      return response.data;
    },
  });

  const addDocumentRevisionWithPromise = (payload: IDocRevisionReq) => {
    setCalled(true);
    return new Promise<IDocument>((resolve, reject) => {
      addDocumentRevision(payload, {
        onSuccess: (data) => resolve(data),
        onError: (err) => reject(err),
      });
    });
  };

  return {
    addDocumentRevision: addDocumentRevisionWithPromise,
    error: error as Error | undefined,
    loading,
    called,
    document: !error && document ? document : undefined,
  };
};

export default useMutateDocSaveAsRevision;
